import { useEffect, useRef } from "react";
import "leaflet/dist/leaflet.css";

// IATA → [lat, lon] for airports commonly seen in SA connection logs at LAX
export const AIRPORTS = {
  // Hub
  LAX: [33.9425, -118.4081],
  // US West
  SFO: [37.6213, -122.3790], SEA: [47.4502, -122.3088], PDX: [45.5898, -122.5951],
  SMF: [38.6954, -121.5908], RNO: [39.4991, -119.7681], FAT: [36.7762, -119.7182],
  SBA: [34.4262, -119.8400], MRY: [36.5870, -121.8428], ACV: [40.9781, -124.1086],
  RDD: [40.5090, -122.2931], BOI: [43.5644, -116.2228], ASE: [39.2232, -106.8689],
  EUG: [44.1246, -123.2119], GEG: [47.6199, -117.5338],
  LAS: [36.0840, -115.1537], PHX: [33.4373, -112.0078], PRC: [34.6545, -112.4198], SAN: [32.7338, -117.1933],
  SNA: [33.6757, -117.8682], OAK: [37.7213, -122.2208], SJC: [37.3626, -121.9290],
  ANC: [61.1743, -149.9963], HNL: [21.3187, -157.9224], OGG: [20.8986, -156.4305],
  KOA: [19.7388, -156.0456], LIH: [21.9760, -159.3390],
  PSP: [33.8297, -116.5067], BUR: [34.2007, -118.3585], ONT: [34.0559, -117.6013],
  SBP: [35.2368, -120.6427], BFL: [35.4336, -119.0568],
  MFR: [42.3742, -122.8735], RDM: [44.2541, -121.1500], OTH: [43.4171, -124.2464],
  YKM: [46.5682, -120.5440], ALW: [46.0949, -118.2887],
  SGU: [37.0363, -113.5103], GJT: [39.1224, -108.5270], DRO: [37.1515, -107.7540],
  MTJ: [38.5098, -107.8939], EGE: [39.6426, -106.9177], HDN: [40.4812, -107.2185],
  JAC: [43.6073, -110.7377], IDA: [43.5146, -112.0702], TWF: [42.4818, -114.4877],
  ABQ: [35.0402, -106.6090], ELP: [31.8072, -106.3779],
  // US Mountain
  BIL: [45.8077, -108.5428], BZN: [45.7775, -111.1603], MSO: [46.9163, -114.0906],
  GTF: [47.4820, -111.3706], HLN: [46.6068, -111.9831], LWS: [46.3745, -117.0149],
  RAP: [44.0453, -103.0574], FSD: [43.5820, -96.7419],  FAR: [46.9207, -96.8158],
  BIS: [46.7727, -100.7467], GFK: [47.9493, -97.1763],
  // US Northeast
  PIT: [40.4915, -80.2329],  BUF: [42.9405, -78.7322],  ALB: [42.7483, -73.8017],
  BDL: [41.9389, -72.6832],  BTV: [44.4720, -73.1533],  ROC: [43.1189, -77.6724],
  RIC: [37.5052, -77.3197],  ORF: [36.8976, -76.0132],  PVD: [41.7243, -71.4281],
  PWM: [43.6462, -70.3094],  SYR: [43.1112, -76.1063],  BGR: [44.8074, -68.8281],
  MHT: [42.9326, -71.4357],  ABE: [40.6521, -75.4408],  AVP: [41.3385, -75.7234],
  MDT: [40.1935, -76.7634],  ERI: [42.0831, -80.1762],  SWF: [41.5041, -74.1048],
  BGM: [42.2082, -75.9798],  ITH: [42.4910, -76.4584],  ELM: [42.1600, -76.8916],
  // US Southeast
  BNA: [36.1245, -86.6782],  TPA: [27.9755, -82.5332],  FLL: [26.0726, -80.1527],
  PBI: [26.6832, -80.0956],  RDU: [35.8776, -78.7875],  MSY: [29.9934, -90.2580],
  MEM: [35.0424, -89.9767],  CHS: [32.8986, -80.0405],  SAV: [32.1276, -81.2021],
  TYS: [35.8110, -83.9940],  MYR: [33.6797, -78.9283],  BTR: [30.5332, -91.1496],
  JAX: [30.4941, -81.6879],  SRQ: [27.3954, -82.5554],  GNV: [29.6900, -82.2717],
  TLH: [30.3965, -84.3503],  PNS: [30.4734, -87.1866],  VPS: [30.4832, -86.5254],
  MOB: [30.6912, -88.2428],  GPT: [30.4073, -89.0701],  JAN: [32.3112, -90.0759],
  BHM: [33.5629, -86.7535],  HSV: [34.6372, -86.7751],  LEX: [38.0365, -84.6059],
  SDF: [38.1744, -85.7360],  EVV: [38.0369, -87.5323],  GSO: [36.0978, -79.9373],
  GSP: [34.8957, -82.2189],  AVL: [35.4362, -82.5418],  CAE: [33.9389, -81.1195],
  ILM: [34.2706, -77.9026],
  // US Midwest
  CMH: [39.9980, -82.8919],  IND: [39.7173, -86.2944],  MCI: [39.2976, -94.7139],
  OMA: [41.3032, -95.8940],  DSM: [41.5339, -93.6631],  MKE: [42.9472, -87.8966],
  MSN: [43.1399, -89.3375],  CVG: [39.0489, -84.6678],  GRR: [42.8808, -85.5228],
  ICT: [37.6499, -97.4331],  STL: [38.7487, -90.3700],  MLI: [41.4485, -90.5076],
  CID: [41.8842, -91.7108],  DBQ: [42.4020, -90.7095],  LSE: [43.8790, -91.2558],
  GRB: [44.4851, -88.1296],  SBN: [41.7087, -86.3172],  FWA: [40.9785, -85.1952],
  FNT: [42.9654, -83.7435],  LAN: [42.7787, -84.5874],  BMI: [40.4771, -88.9158],
  SPI: [39.8441, -89.6784],  TVC: [44.7414, -85.5822],
  // US South / Central
  ORD: [41.9742, -87.9073],  IAH: [29.9902, -95.3368],  EWR: [40.6895, -74.1745],
  JFK: [40.6413, -73.7781],  BOS: [42.3656, -71.0096],  MIA: [25.7959, -80.2870],
  MCO: [28.4312, -81.3081],  RSW: [26.5362, -81.7552],  CLE: [41.4117, -81.8498],
  ATL: [33.6407, -84.4277],  CLT: [35.2140, -80.9431],  IAD: [38.9531, -77.4565],
  DCA: [38.8521, -77.0377],  MSP: [44.8848, -93.2223],  DTW: [42.2124, -83.3534],
  DEN: [39.8561, -104.6737], SLC: [40.7884, -111.9778],  DFW: [32.8998, -97.0403],
  LGA: [40.7772, -73.8726],  PHL: [39.8721, -75.2411],  BWI: [39.1754, -76.6683],
  AUS: [30.1975, -97.6664],  SAT: [29.5337, -98.4698],  OKC: [35.3931, -97.6007],
  TUL: [36.1984, -95.8881],  XNA: [36.2819, -94.3069],  SGF: [37.2457, -93.3886],
  SHV: [32.4466, -93.8257],  CRP: [27.7704, -97.5013],  HRL: [26.2285, -97.6544],
  LBB: [33.6636, -101.8229], MAF: [31.9425, -102.2017], ABI: [32.4113, -99.6819],
  // US Territories
  SJU: [18.4394, -66.0018],  BQN: [18.4949, -67.1294],  STT: [18.3373, -64.9733],
  STX: [17.7019, -64.7985],  GUM: [13.4834, 144.7960],   SPN: [15.1190, 145.7290],
  // Canada
  YVR: [49.1967, -123.1815], YYZ: [43.6777, -79.6248],  YUL: [45.4706, -73.7408],
  YYC: [51.1315, -114.0106], YEG: [53.3097, -113.5797],  YWG: [49.9100, -97.2398],
  YOW: [45.3225, -75.6692],  YHZ: [44.8808, -63.5086],  YQB: [46.7911, -71.3933],
  // Mexico
  MEX: [19.4363, -99.0721],  CUN: [21.0365, -86.8771],  GDL: [20.5218, -103.3111],
  SJD: [23.1518, -109.7211], PVR: [20.6801, -105.2544],  MTY: [25.7785, -100.1068],
  MZT: [23.1614, -106.2658], ZIH: [17.6016, -101.4605],  HMO: [29.0959, -111.0479],
  BJX: [20.9935, -101.4809], CZM: [20.5224, -86.9257],  MID: [20.9370, -89.6577],
  OAX: [16.9999, -96.7266],  QRO: [20.6173, -100.1856],  ZLO: [19.1448, -104.5588],
  TQO: [20.2280, -87.4738],
  // Central America
  GUA: [14.5833, -90.5275],  SAL: [13.4409, -89.0557],  PTY: [9.0714, -79.3835],
  SJO: [9.9939,  -84.2088],  LIR: [10.5933, -85.5444],  MGA: [12.1415, -86.1681],
  SAP: [15.4526, -87.9236],  RTB: [16.3162, -86.5230],
  // Caribbean
  NAS: [25.0390, -77.4662],  MBJ: [18.5037, -77.9134],  KIN: [17.9357, -76.7875],
  PUJ: [18.5674, -68.3634],  SXM: [18.0410, -63.1089],  AUA: [12.5014, -70.0152],
  GCM: [19.2928, -81.3577],  BGI: [13.0746, -59.4925],  PLS: [21.7736, -72.2659],
  POS: [10.5954, -61.3372],
  // Europe
  LHR: [51.4775, -0.4614],   CDG: [49.0097, 2.5479],    FRA: [50.0379, 8.5622],
  ZRH: [47.4647, 8.5492],    AMS: [52.3086, 4.7639],    VIE: [48.1103, 16.5697],
  FCO: [41.7999, 12.2462],   MAD: [40.4983, -3.5676],   BCN: [41.2974, 2.0833],
  CPH: [55.6180, 12.6508],   OSL: [60.1939, 11.1004],   ARN: [59.6498, 17.9238],
  HEL: [60.3172, 24.9633],   WAW: [52.1657, 20.9671],   BRU: [50.9014, 4.4844],
  MUC: [48.3537, 11.7750],   LIS: [38.7742, -9.1342],   IST: [41.2753, 28.7519],
  ATH: [37.9364, 23.9445],   DUS: [51.2895, 6.7668],    MXP: [45.6306, 8.7281],
  GVA: [46.2380, 6.1089],    PRG: [50.1008, 14.2600],   BUD: [47.4298, 19.2611],
  EDI: [55.9500, -3.3725],   DUB: [53.4213, -6.2700],   SNN: [52.7020, -8.9248],
  NCE: [43.6584, 7.2159],    BER: [52.3667, 13.5033],   VCE: [45.5053, 12.3519],
  NAP: [40.8860, 14.2908],   AGP: [36.6749, -4.4991],   PMI: [39.5517, 2.7388],
  OPO: [41.2481, -8.6814],   KEF: [63.9850, -22.6056],  DBV: [42.5614, 18.2681],
  BRI: [41.1389, 16.7603],   SPU: [43.5389, 16.2980],   GLA: [55.8719, -4.4331],
  // East Asia
  NRT: [35.7647, 140.3864],  HND: [35.5494, 139.7798],  KIX: [34.4320, 135.2440],
  NGO: [34.8583, 136.8050],  ICN: [37.4602, 126.4407],  GMP: [37.5583, 126.7906],
  PEK: [40.0799, 116.6031],  PVG: [31.1443, 121.8083],  CAN: [23.3924, 113.2988],
  HKG: [22.3080, 113.9185],  TPE: [25.0777, 121.2326],
  // SE Asia / India / Middle East
  SGN: [10.8188, 106.6520],  SIN: [1.3644,  103.9915],  KUL: [2.7456,  101.7072],
  BKK: [13.6900, 100.7501],  MNL: [14.5086, 121.0197],  CGK: [-6.1256, 106.6559],
  DEL: [28.5562, 77.1000],   BOM: [19.0896, 72.8656],   MAA: [12.9900, 80.1693],
  HYD: [17.2403, 78.4294],   CMB: [7.1808,  79.8841],   DAC: [23.8433, 90.3978],
  DXB: [25.2532, 55.3657],   DOH: [25.2731, 51.6082],   AUH: [24.4330, 54.6511],
  RUH: [24.9578, 46.6989],   AMM: [31.7226, 35.9932],   CAI: [30.1219, 31.4056],
  TLV: [32.0114, 34.8867],
  // Oceania / Pacific
  SYD: [-33.9399, 151.1753], MEL: [-37.6733, 144.8430], BNE: [-27.3842, 153.1175],
  ADL: [-34.9450, 138.5300], PER: [-31.9403, 115.9669], AKL: [-37.0082, 174.7850],
  CHC: [-43.4894, 172.5322], PPT: [-17.5534, -149.6068], ROR: [7.3675,  134.5440],
  ULN: [47.8431, 106.7660],
  // Africa
  JNB: [-26.1392, 28.2460],  CPT: [-33.9648, 18.6017],  NBO: [-1.3192, 36.9275],
  ADD: [8.9779,  38.7993],   ACC: [5.6052,  -0.1668],   LOS: [6.5774,  3.3212],
  DSS: [14.6704, -17.0727],  RAK: [31.6069, -8.0363],
  // Latin America
  GRU: [-23.4356, -46.4731], GIG: [-22.8099, -43.2505], EZE: [-34.8222, -58.5358],
  BOG: [4.7016,  -74.1469],  LIM: [-12.0219, -77.1143], SCL: [-33.3930, -70.7858],
  MDE: [6.1645,  -75.4231],  GYE: [-2.1574,  -79.8836], UIO: [-0.1292,  -78.3575],
  // Greenland / Arctic
  GOH: [64.1909, -51.6781],
};

const LAX = AIRPORTS.LAX;

function greatCircle(lat1, lon1, lat2, lon2, n = 80) {
  const R = Math.PI / 180;
  const φ1 = lat1*R, λ1 = lon1*R, φ2 = lat2*R, λ2 = lon2*R;
  const d = 2 * Math.asin(Math.sqrt(
    Math.sin((φ2-φ1)/2)**2 + Math.cos(φ1)*Math.cos(φ2)*Math.sin((λ2-λ1)/2)**2
  ));
  if (d === 0) return [[lat1, lon1]];
  const raw = Array.from({ length: n + 1 }, (_, i) => {
    const f = i / n;
    const A = Math.sin((1-f)*d) / Math.sin(d);
    const B = Math.sin(f*d)     / Math.sin(d);
    const x = A*Math.cos(φ1)*Math.cos(λ1) + B*Math.cos(φ2)*Math.cos(λ2);
    const y = A*Math.cos(φ1)*Math.sin(λ1) + B*Math.cos(φ2)*Math.sin(λ2);
    const z = A*Math.sin(φ1)               + B*Math.sin(φ2);
    return [Math.atan2(z, Math.sqrt(x*x + y*y)) / R, Math.atan2(y, x) / R];
  });
  // Unwrap longitudes so consecutive points never jump >180° —
  // prevents Leaflet from drawing the "wrong way around" across the antimeridian.
  for (let i = 1; i < raw.length; i++) {
    let lon = raw[i][1];
    const prev = raw[i - 1][1];
    while (lon - prev >  180) lon -= 360;
    while (lon - prev < -180) lon += 360;
    raw[i] = [raw[i][0], lon];
  }
  return raw;
}

function codeLabel(code, color, shadow) {
  return `<span style="color:${color};font-size:10px;font-weight:700;font-family:'HelveticaNeueStd','Barlow','Helvetica Neue',Arial,sans-serif;text-shadow:${shadow};white-space:nowrap;letter-spacing:0.04em">${code}</span>`;
}

export default function FlightRouteMap({ origin, dest, isDark = true }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    // eslint-disable-next-line import/no-extraneous-dependencies
    const L = require("leaflet");

    const isTouch = L.Browser.touch;
    const map = L.map(containerRef.current, {
      scrollWheelZoom: false,
      zoomControl: false,
      attributionControl: false,
      dragging: !isTouch,
      touchZoom: !isTouch,
      tap: false,
    });

    const base = isDark ? "dark_nolabels" : "light_nolabels";
    const cartoKey = process.env.REACT_APP_CARTO_API_KEY;
    L.tileLayer(`https://{s}.basemaps.cartocdn.com/${base}/{z}/{x}/{y}.png${cartoKey ? `?key=${cartoKey}` : ""}`,
      { maxZoom: 8, minZoom: 1, subdomains: "abcd" }
    ).addTo(map);

    const originCoords = origin ? AIRPORTS[origin.toUpperCase()] : null;
    const destCoords   = dest   ? AIRPORTS[dest.toUpperCase()]   : null;

    // Compute arcs. The inbound arc may cross the antimeridian, unwrapping LAX's
    // longitude away from its canonical -118°. The outbound arc must be shifted
    // by the same offset so both arcs share one coordinate frame — otherwise
    // fitBounds sees a 360° span and zooms out to show the whole world.
    let inboundArc = null;
    let outboundArc = null;

    // Skip arc when the airport IS LAX — greatCircle(LAX, LAX) returns a
    // 1-point array and Leaflet silently draws nothing for a 1-point polyline.
    if (originCoords && origin?.toUpperCase() !== "LAX") {
      inboundArc = greatCircle(originCoords[0], originCoords[1], LAX[0], LAX[1]);
    }
    if (destCoords && dest?.toUpperCase() !== "LAX") {
      outboundArc = greatCircle(LAX[0], LAX[1], destCoords[0], destCoords[1]);
      if (inboundArc) {
        // LAX's longitude in the inbound arc's unwrapped frame vs canonical
        const laxUnwrapped = inboundArc[inboundArc.length - 1][1];
        const offset = laxUnwrapped - LAX[1];
        if (Math.abs(offset) > 1) {
          outboundArc = outboundArc.map(([lat, lon]) => [lat, lon + offset]);
        }
      }
    }

    // Use arc endpoints for marker positions so they land in the same world-copy
    // as the arcs. Canonical coords (-118° for LAX) are in the wrong copy when
    // the map is centered over the Pacific (extended longitude ~191°).
    const originPos = inboundArc ? inboundArc[0]                        : originCoords;
    const laxPos    = inboundArc ? inboundArc[inboundArc.length - 1]    : LAX;
    const destPos   = outboundArc ? outboundArc[outboundArc.length - 1] : destCoords;

    // Inject animation keyframes into the map container
    const styleEl = document.createElement("style");
    styleEl.textContent = `
      @keyframes routeFlow { to { stroke-dashoffset: -12; } }
      .route-anim { animation: routeFlow 2.8s linear infinite; }
    `;
    containerRef.current.appendChild(styleEl);

    const colorIn  = isDark ? "#38bdf8" : "#0284c7";
    const colorOut = isDark ? "#fbbf24" : "#d97706";
    const colorLax = isDark ? "#fff"    : "#1a2a4a";

    if (inboundArc && inboundArc.length >= 2) {
      L.polyline(inboundArc, { color: colorIn, weight: 2.5, opacity: 0.9, dashArray: "7 5", className: "route-anim" }).addTo(map);
      L.circleMarker(originPos, {
        radius: 5, color: colorIn, fillColor: colorIn, fillOpacity: 1, weight: 2,
      }).addTo(map);
    }

    if (outboundArc && outboundArc.length >= 2) {
      L.polyline(outboundArc, { color: colorOut, weight: 2.5, opacity: 0.9, dashArray: "7 5", className: "route-anim" }).addTo(map);
      L.circleMarker(destPos, {
        radius: 5, color: colorOut, fillColor: colorOut, fillOpacity: 1, weight: 2,
      }).addTo(map);
    }

    // LAX marker — use unwrapped position from arc so it lands in the correct world copy
    L.circleMarker(laxPos, {
      radius: 6, color: colorLax, fillColor: colorLax, fillOpacity: 1, weight: 2,
    }).addTo(map);

    // Fit to just the airport markers (not the full arc) so the map zooms in
    // closer to the endpoints — arc lines may be clipped but labels stay visible.
    const markerPoints = [
      ...(originPos ? [originPos] : []),
      laxPos,
      ...(destPos ? [destPos] : []),
    ];
    // Place labels/chevrons after the map settles. Using setTimeout(0) instead of
    // once("moveend") because fitBounds may skip firing moveend when the computed
    // bounds are identical to the current view (e.g. LAX-only entries with one arc).
    const placeOverlays = () => {
      // Single directional chevron at arc midpoint
      const addChevrons = (arc, color) => {
        const mid = Math.floor(arc.length / 2);
        // Compute bearing from geographic coords — avoids latLngToContainerPoint
        // wrapping unwrapped longitudes (< -180°) to the wrong world copy.
        const R = Math.PI / 180;
        const [lat1, lon1] = [arc[mid][0] * R,     arc[mid][1] * R];
        const [lat2, lon2] = [arc[mid + 1][0] * R, arc[mid + 1][1] * R];
        const dLon = lon2 - lon1;
        const y = Math.sin(dLon) * Math.cos(lat2);
        const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
        // Geographic bearing (0=N, 90=E) → Mercator screen angle (0=right, 90=down)
        const angle = Math.atan2(y, x) * 180 / Math.PI - 90;
        L.marker(arc[mid], {
          icon: L.divIcon({
            className: "",
            html: `<svg width="12" height="12" viewBox="0 0 12 12" style="display:block;transform:rotate(${angle}deg)"><polyline points="2,1 9,6 2,11" stroke="${color}" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
            iconSize: [12, 12],
            iconAnchor: [6, 6],
          }),
        }).addTo(map);
      };
      if (inboundArc)  addChevrons(inboundArc,  colorIn);
      if (outboundArc) addChevrons(outboundArc, colorOut);

      const LW = 28, LH = 12, DOT_R = 8;
      const items = [
        inboundArc  ? { code: origin.toUpperCase(), pos: originPos, color: colorIn  } : null,
        { code: "LAX", pos: laxPos, color: colorLax },
        outboundArc ? { code: dest.toUpperCase(),   pos: destPos,   color: colorOut } : null,
      ].filter(Boolean);

      const withPx = items.map(item => ({ ...item, px: map.latLngToContainerPoint(item.pos) }));

      // Candidate placements tried in order: right, left, above, below
      const PLACEMENTS = [
        [-7,     LH / 2],  // right
        [LW + 7, LH / 2],  // left
        [LW / 2, LH + 7],  // above
        [LW / 2, -7],      // below
      ];

      // [x1, y1, x2, y2] bounding box for a label placed with iconAnchor [ax, ay]
      const labelBox = (px, [ax, ay]) => [px.x - ax, px.y - ay, px.x - ax + LW, px.y - ay + LH];
      const boxesOverlap = (a, b) => a[0] < b[2] && a[2] > b[0] && a[1] < b[3] && a[3] > b[1];
      const hitsDot = (b, dot) =>
        b[0] < dot.x + DOT_R && b[2] > dot.x - DOT_R &&
        b[1] < dot.y + DOT_R && b[3] > dot.y - DOT_R;

      // Liang-Barsky segment-vs-AABB: returns true if segment (ax,ay)→(bx,by) crosses box
      const segHitsBox = (ax, ay, bx, by, rx1, ry1, rx2, ry2) => {
        const dx = bx - ax, dy = by - ay;
        let t0 = 0, t1 = 1;
        const ps = [-dx, dx, -dy, dy];
        const qs = [ax - rx1, rx2 - ax, ay - ry1, ry2 - ay];
        for (let i = 0; i < 4; i++) {
          if (ps[i] === 0) { if (qs[i] < 0) return false; }
          else {
            const r = qs[i] / ps[i];
            if (ps[i] < 0) { if (r > t1) return false; if (r > t0) t0 = r; }
            else            { if (r < t0) return false; if (r < t1) t1 = r; }
          }
        }
        return t0 <= t1;
      };

      // Build pixel-space arc segments near each airport endpoint for label avoidance
      const N = 14; // number of arc points to sample near each endpoint
      const toPxPairs = (arc) => {
        const pxPts = arc.map(p => map.latLngToContainerPoint(p));
        const pairs = [];
        for (let i = 1; i < pxPts.length; i++) pairs.push([pxPts[i-1], pxPts[i]]);
        return pairs;
      };
      const arcPxNearOrigin = inboundArc  ? toPxPairs(inboundArc.slice(0, N))   : [];
      const arcPxNearLaxIn  = inboundArc  ? toPxPairs(inboundArc.slice(-N))      : [];
      const arcPxNearLaxOut = outboundArc ? toPxPairs(outboundArc.slice(0, N))   : [];
      const arcPxNearDest   = outboundArc ? toPxPairs(outboundArc.slice(-N))     : [];

      const hitsArc = (b, pairs) =>
        pairs.some(([p1, p2]) => segHitsBox(p1.x, p1.y, p2.x, p2.y, b[0], b[1], b[2], b[3]));

      const usedBoxes = [];
      const containerSize = map.getSize();
      const inContainer = (b) => b[0] >= 0 && b[1] >= 0 && b[2] <= containerSize.x && b[3] <= containerSize.y;

      withPx.forEach(item => {
        const otherPx = withPx.filter(o => o.code !== item.code).map(o => o.px);

        // Arc segments that terminate at this airport — used to steer label away from the line
        let nearPairs = [];
        if (item.code === origin?.toUpperCase()) nearPairs = arcPxNearOrigin;
        else if (item.code === "LAX")            nearPairs = [...arcPxNearLaxIn, ...arcPxNearLaxOut];
        else if (item.code === dest?.toUpperCase()) nearPairs = arcPxNearDest;

        // Tier 1: fully valid (in-bounds + no arc + no dot overlap)
        // Tier 2: in-bounds + no dot overlap (arc overlap tolerated)
        // Tier 3: any in-bounds placement (always better than clipping off-screen)
        let anchor = null;
        let tier2 = null;
        let tier3 = null;

        for (const pl of PLACEMENTS) {
          const b = labelBox(item.px, pl);
          if (!inContainer(b)) continue;
          if (!tier3) tier3 = pl;
          if (otherPx.some(dot => hitsDot(b, dot))) continue;
          if (!tier2) tier2 = pl;
          if (usedBoxes.some(ub => boxesOverlap(b, ub)) || hitsArc(b, nearPairs)) continue;
          anchor = pl;
          break;
        }
        if (!anchor) anchor = tier2 ?? tier3 ?? PLACEMENTS[0];

        usedBoxes.push(labelBox(item.px, anchor));
        L.marker(item.pos, {
          icon: L.divIcon({ className: "", html: codeLabel(item.code, item.color, isDark ? "0 1px 4px rgba(0,0,0,0.9)" : "0 0 4px rgba(255,255,255,0.95),0 1px 3px rgba(255,255,255,0.8)"), iconAnchor: anchor }),
        }).addTo(map);
      });
    };

    if (markerPoints.length > 1) {
      map.fitBounds(markerPoints, { padding: [10, 10], maxZoom: 7 });
    } else {
      map.setView(LAX, 5);
    }
    // Defer overlay placement so the map has finished rendering its new bounds.
    // setTimeout(0) yields to the browser's layout/paint cycle; Leaflet's internal
    // moveend fires (if it does) before this callback runs.
    const overlayTimer = setTimeout(placeOverlays, 0);

    return () => { clearTimeout(overlayTimer); map.remove(); };
  }, [origin, dest, isDark]);

  return (
    <div style={{ position: "relative", height: 180, width: "100%" }}>
      <div ref={containerRef} style={{ height: "100%", width: "100%" }} />
      <div style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        background: isDark
          ? "radial-gradient(ellipse at center, transparent 35%, rgba(10,15,30,0.80) 100%)"
          : "radial-gradient(ellipse at center, transparent 35%, rgba(220,228,248,0.75) 100%)",
      }} />
    </div>
  );
}
